var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',{attrs:{"data-type":`experience-${_vm.item.uuid}`,"to":{
    name: 'product-permalink',
    params: {
      type: _vm.$t(`router.product_permalink.type.${_vm.item.type}`),
      permalink: _vm.item.permalink,
    },
  }}},[_c('span',{staticClass:"item-search-title"},[_vm._v(_vm._s(_vm.item.name)+", "+_vm._s(_vm.item.country.name))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"item-search-description"},[_vm._v(_vm._s(_vm.item.headline))])])
}
var staticRenderFns = []

export { render, staticRenderFns }